/* TypeScript file generated from Presse.res by genType. */
/* eslint-disable import/first */


import * as React from 'react';

// @ts-ignore: Implicit any on import
import * as PresseBS__Es6Import from './Presse.bs';
const PresseBS: any = PresseBS__Es6Import;

import type {Amplitude_pageViewTracker as Tracking_Amplitude_pageViewTracker} from '../../src/provider/Tracking.gen';

import type {Amplitude_userActionTracker as Tracking_Amplitude_userActionTracker} from '../../src/provider/Tracking.gen';

import type {Focus_t as ReactEvent_Focus_t} from '../../src/shim/ReactEvent.shim';

import type {Guide_t as Presse_Page_Guide_t} from '../../src/presse/Presse_Page.gen';

import type {Item_t as Type_Dropdown_Item_t} from '../../src/type/Type_Dropdown.gen';

import type {Item_value as Type_Dropdown_Item_value} from '../../src/type/Type_Dropdown.gen';

import type {Presse_Button_presseStyle as Atom_Cta_Presse_Button_presseStyle} from '../../src/design-system/atom/Atom_Cta.gen';

import type {Presse_disabled as Atom_Cta_Ds_Presse_disabled} from '../../src/design-system/atom/Atom_Cta_Ds.gen';

import type {Presse_variant as Atom_Text_Presse_variant} from '../../src/design-system/atom/Atom_Text.gen';

import type {Select_variant as Organism_Dropdown_Ds_Select_variant} from '../../src/design-system/organism/dropdown/Organism_Dropdown_Ds.gen';

import type {Teaser_Id_t as Type_String_Teaser_Id_t} from '../../src/type/Type_String.gen';

import type {account as Type_Organism_Menu_account} from '../../src/type/Type_Organism_Menu.gen';

import type {alt as Atom_Box_alt} from '../../src/design-system/atom/Atom_Box.gen';

import type {api as Context_Config_api} from '../../src/provider/Context_Config.gen';

import type {appGalleryUrl as Context_Config_appGalleryUrl} from '../../src/provider/Context_Config.gen';

import type {appStoreUrl as Context_Config_appStoreUrl} from '../../src/provider/Context_Config.gen';

import type {ariaLabel as Particle_Accessibility_ariaLabel} from '../../src/design-system/particle/Particle_Accessibility.gen';

import type {autoComplete as Atom_Select_autoComplete} from '../../src/design-system/atom/Atom_Select.gen';

import type {autoComplete as Atom_Textfield_autoComplete} from '../../src/design-system/atom/Atom_Textfield.gen';

import type {brand as Type_Organism_Menu_brand} from '../../src/type/Type_Organism_Menu.gen';

import type {color as Atom_Icon_Ds_color} from '../../src/design-system/atom/Atom_Icon_Ds.gen';

import type {content as Organism_Carousel_Presse_content} from '../../src/design-system/organism/carousel/Organism_Carousel_Presse.gen';

import type {createVideoElement as Context_Config_createVideoElement} from '../../src/provider/Context_Config.gen';

import type {formaters as Context_I18n_formaters} from '../../src/provider/Context_I18n.gen';

import type {href as Atom_Box_href} from '../../src/design-system/atom/Atom_Box.gen';

import type {htmlFor as Atom_Box_htmlFor} from '../../src/design-system/atom/Atom_Box.gen';

import type {id as Type_Organism_Menu_id} from '../../src/type/Type_Organism_Menu.gen';

import type {isPlayNextActivated as Type_Page_Program_isPlayNextActivated} from '../../src/type/Type_Page_Program.gen';

import type {jsEntry as FeatureFlipping_jsEntry} from '../../src/FeatureFlipping.gen';

import type {language as Type_Common_language} from '../../src/type/Type_Common.gen';

import type {link as Type_Organism_Menu_link} from '../../src/type/Type_Organism_Menu.gen';

import type {more as Type_Organism_Menu_more} from '../../src/type/Type_Organism_Menu.gen';

import type {name as Atom_Box_name} from '../../src/design-system/atom/Atom_Box.gen';

import type {onBlur as Atom_Select_onBlur} from '../../src/design-system/atom/Atom_Select.gen';

import type {onBlur as Atom_Textfield_onBlur} from '../../src/design-system/atom/Atom_Textfield.gen';

import type {onChange as Atom_Textfield_onChange} from '../../src/design-system/atom/Atom_Textfield.gen';

import type {onPlayNextChange as Type_Page_Program_onPlayNextChange} from '../../src/type/Type_Page_Program.gen';

import type {playStoreUrl as Context_Config_playStoreUrl} from '../../src/provider/Context_Config.gen';

import type {programTrackingHandler as Tracking_programTrackingHandler} from '../../src/provider/Tracking.gen';

import type {resolution as Type_Teaser_resolution} from '../../src/type/Type_Teaser.gen';

import type {search as Organism_Header_search} from '../../src/design-system/organism/header/Organism_Header.gen';

import type {search as Type_Organism_Menu_search} from '../../src/type/Type_Organism_Menu.gen';

import type {serverTime as Context_Config_serverTime} from '../../src/provider/Context_Config.gen';

import type {t as Emac_Footer_t} from '../../src/emac/Emac_Footer.gen';

import type {t as Presse_Page_t} from '../../src/presse/Presse_Page.gen';

import type {t as Type_Pattern_t} from '../../src/type/Type_Pattern.gen';

import type {t as Type_Translation_t} from '../../src/generated/Type_Translation.gen';

import type {text as Atom_Box_text} from '../../src/design-system/atom/Atom_Box.gen';

import type {type_ as Atom_Box_type_} from '../../src/design-system/atom/Atom_Box.gen';

import type {vodStoreHomepageUrl as Context_Config_vodStoreHomepageUrl} from '../../src/provider/Context_Config.gen';

// tslint:disable-next-line:interface-over-type-literal
export type I18nProvider_Props = {
  readonly children: React.ReactNode; 
  readonly formaters: Context_I18n_formaters; 
  readonly labels: Type_Translation_t; 
  readonly locale: Type_Common_language; 
  readonly loginUrl?: string; 
  readonly myArteBaseUrl?: string; 
  readonly profileUrl?: string
};

export const I18nProvider: React.FC<{
  readonly children: React.ReactNode; 
  readonly formaters: Context_I18n_formaters; 
  readonly labels: Type_Translation_t; 
  readonly locale: Type_Common_language; 
  readonly loginUrl?: string; 
  readonly myArteBaseUrl?: string; 
  readonly profileUrl?: string
}> = function Presse_I18nProvider(Arg1: any) {
  const $props = {children:Arg1.children, formaters:{addFavorite:Arg1.formaters.addFavorite, availabilityDate:(Arg1.formaters.availabilityDate == null ? Arg1.formaters.availabilityDate : function (Arg11: any) {
      const result1 = Arg1.formaters.availabilityDate({type:Arg11.type_, start:Arg11.start});
      return result1
    }), betweenDates:(Arg1.formaters.betweenDates == null ? Arg1.formaters.betweenDates : function (Arg12: any) {
      const result2 = Arg1.formaters.betweenDates({start:Arg12.start, end:Arg12.end_});
      return result2
    }), date:Arg1.formaters.date, dateWithFormat:Arg1.formaters.dateWithFormat, nextBroadcastDate:Arg1.formaters.nextBroadcastDate, nextEpisode:Arg1.formaters.nextEpisode, progress:Arg1.formaters.progress, removeFavorite:Arg1.formaters.removeFavorite, watchTrailer:Arg1.formaters.watchTrailer, weekInterval:Arg1.formaters.weekInterval, infoSelectedDay:Arg1.formaters.infoSelectedDay, formValidationStringMin:Arg1.formaters.formValidationStringMin, formValidationStringMax:Arg1.formaters.formValidationStringMax}, labels:Arg1.labels, locale:Arg1.locale, loginUrl:Arg1.loginUrl, myArteBaseUrl:Arg1.myArteBaseUrl, profileUrl:Arg1.profileUrl};
  const result = React.createElement(PresseBS.I18nProvider, $props);
  return result
};

// tslint:disable-next-line:interface-over-type-literal
export type ConfigProvider_Props = {
  readonly api?: Context_Config_api; 
  readonly appGalleryUrl: Context_Config_appGalleryUrl; 
  readonly appStoreUrl: Context_Config_appStoreUrl; 
  readonly baseUrl: string; 
  readonly cdnUrl?: string; 
  readonly children: React.ReactNode; 
  readonly createVideoElement?: Context_Config_createVideoElement; 
  readonly featureFlippings?: FeatureFlipping_jsEntry; 
  readonly playStoreUrl: Context_Config_playStoreUrl; 
  readonly serverTime?: Context_Config_serverTime; 
  readonly ssoApiKey?: string; 
  readonly ssoTokenApiKey?: string; 
  readonly trackPageView: (null | undefined | Tracking_Amplitude_pageViewTracker); 
  readonly trackPixel: (null | undefined | Tracking_programTrackingHandler); 
  readonly trackUserAction: (null | undefined | Tracking_Amplitude_userActionTracker); 
  readonly vodStoreHomepageUrl: Context_Config_vodStoreHomepageUrl
};

export const ConfigProvider: React.FC<{
  readonly api?: Context_Config_api; 
  readonly appGalleryUrl: Context_Config_appGalleryUrl; 
  readonly appStoreUrl: Context_Config_appStoreUrl; 
  readonly baseUrl: string; 
  readonly cdnUrl?: string; 
  readonly children: React.ReactNode; 
  readonly createVideoElement?: Context_Config_createVideoElement; 
  readonly featureFlippings?: FeatureFlipping_jsEntry; 
  readonly playStoreUrl: Context_Config_playStoreUrl; 
  readonly serverTime?: Context_Config_serverTime; 
  readonly ssoApiKey?: string; 
  readonly ssoTokenApiKey?: string; 
  readonly trackPageView: (null | undefined | Tracking_Amplitude_pageViewTracker); 
  readonly trackPixel: (null | undefined | Tracking_programTrackingHandler); 
  readonly trackUserAction: (null | undefined | Tracking_Amplitude_userActionTracker); 
  readonly vodStoreHomepageUrl: Context_Config_vodStoreHomepageUrl
}> = function Presse_ConfigProvider(Arg1: any) {
  const $props = {api:(Arg1.api == null ? undefined : {loadNextPage:Arg1.api.loadNextPage, isTeaserAvailable:Arg1.api.isTeaserAvailable, getNextPageUrl:(Arg1.api.getNextPageUrl == null ? undefined : function (Arg11: any, Arg2: any) {
      const result1 = Arg1.api.getNextPageUrl(Arg11, Arg2);
      return (result1 == null ? undefined : result1)
    }), getPageUrl:(Arg1.api.getPageUrl == null ? undefined : function (Arg12: any, Arg21: any) {
      const result2 = Arg1.api.getPageUrl(Arg12, Arg21);
      return (result2 == null ? undefined : result2)
    }), getTrailerUrl:Arg1.api.getTrailerUrl, showPrivacyCenter:Arg1.api.showPrivacyCenter, subscribeToNewsletter:(Arg1.api.subscribeToNewsletter == null ? undefined : function (Arg13: any, Arg22: any, Arg3: any) {
      const result3 = Arg1.api.subscribeToNewsletter(Arg13, Arg22, Arg3);
      return result3.then(function _element($promise: any) { return $promise.tag==="Ok"
        ? {TAG: 0, _0:$promise.value} as any
        : {TAG: 1, _0:$promise.value} as any})
    }), onLogoutCallback:Arg1.api.onLogoutCallback, consentStatus:Arg1.api.consentStatus}), appGalleryUrl:Arg1.appGalleryUrl, appStoreUrl:Arg1.appStoreUrl, baseUrl:Arg1.baseUrl, cdnUrl:Arg1.cdnUrl, children:Arg1.children, createVideoElement:(Arg1.createVideoElement == null ? undefined : function (ArgplaySetter: any, ArgpauseSetter: any, ArgvideoKind: any, ArgvideoUrl: any, ArgonPlayerReady: any, ArgpreviewImage: any) {
      const result4 = Arg1.createVideoElement({playSetter:ArgplaySetter, pauseSetter:ArgpauseSetter, videoKind:ArgvideoKind, videoUrl:ArgvideoUrl, onPlayerReady:ArgonPlayerReady, previewImage:ArgpreviewImage});
      return result4
    }), featureFlippings:Arg1.featureFlippings, playStoreUrl:Arg1.playStoreUrl, serverTime:Arg1.serverTime, ssoApiKey:Arg1.ssoApiKey, ssoTokenApiKey:Arg1.ssoTokenApiKey, trackPageView:Arg1.trackPageView, trackPixel:Arg1.trackPixel, trackUserAction:Arg1.trackUserAction, vodStoreHomepageUrl:Arg1.vodStoreHomepageUrl};
  const result = React.createElement(PresseBS.ConfigProvider, $props);
  return result
};

/** 
 * @remarks needed to reset styles
 * Optionnally, you can pass a withFont option to make() in order to import the fontFaces from the design system
 * @example
 * ```javascript
 *  import { globalStyle } from '@artegeie/design-system/presse'
 *  const App = () => { globalStyle() }
 * ```
 * @remarks
  */
export const globalStyle: (withFont:boolean) => void = PresseBS.globalStyle;

// tslint:disable-next-line:interface-over-type-literal
export type Carousel_Props = {
  readonly content: Organism_Carousel_Presse_content; 
  readonly id: string; 
  readonly label: string
};

/** 
*@example
*```javascript
* import {Carousel} from '@artegeie/desing-system/presse'
*
* const srcs = [
*   {
*     url: "https://www.arte.tv/sites/presse/files/099727-000-a_3472315-scaled.jpg",
*     w: 864,
*     h: 484,
*   },
*   {...},
* ]
*
* const content = [
*   {
*     title: "title",
*     subtitle: "subtitle",
*     description: "description",
*     imageSrc: srcs,
*     imageAlt: "alt text",
*     href: "https://...",
*   },
*   {...},
* ]
*
* const App = () => {
*   <Carousel id="my-Id" label="carousel_presse" content={content} />
* }
*```
 */
export const Carousel: React.FC<{
  readonly content: Organism_Carousel_Presse_content; 
  readonly id: string; 
  readonly label: string
}> = PresseBS.Carousel;

// tslint:disable-next-line:interface-over-type-literal
export type Menu_Props = {
  readonly account?: Type_Organism_Menu_account; 
  readonly brand?: Type_Organism_Menu_brand; 
  readonly buttonMore: Type_Organism_Menu_more; 
  readonly currentLinkId?: Type_Organism_Menu_id; 
  readonly links: Type_Organism_Menu_link[]; 
  readonly navLabel: Particle_Accessibility_ariaLabel; 
  readonly search?: Type_Organism_Menu_search
};

/** 
 * @example
 * ```javascript
 *  import { Menu } from '@artegeie/design-system/presse'
 *
 *  const App = () =>
 *    <Menu {...props} />
 * ```
 *
  */
export const Menu: React.FC<{
  readonly account?: Type_Organism_Menu_account; 
  readonly brand?: Type_Organism_Menu_brand; 
  readonly buttonMore: Type_Organism_Menu_more; 
  readonly currentLinkId?: Type_Organism_Menu_id; 
  readonly links: Type_Organism_Menu_link[]; 
  readonly navLabel: Particle_Accessibility_ariaLabel; 
  readonly search?: Type_Organism_Menu_search
}> = function Presse_Menu(Arg1: any) {
  const $props = {account:Arg1.account, brand:(Arg1.brand == null ? undefined : {logo:{TAG: 0, _0:Arg1.brand.logo[0], _1:Arg1.brand.logo[1]} as any, title:Arg1.brand.title, titleHref:Arg1.brand.titleHref, titleKind:Arg1.brand.titleKind}), buttonMore:Arg1.buttonMore, currentLinkId:Arg1.currentLinkId, links:Arg1.links, navLabel:Arg1.navLabel, search:Arg1.search};
  const result = React.createElement(PresseBS.Menu, $props);
  return result
};

// tslint:disable-next-line:interface-over-type-literal
export type TopTeaser_Props = {
  readonly description: string; 
  readonly href: Atom_Box_href; 
  readonly imageAlt: Atom_Box_alt; 
  readonly imageSrc: Type_Teaser_resolution[]; 
  readonly ref_?: any; 
  readonly subtitle: string; 
  readonly title: string
};

/** 
 * @example
 * ```javascript
 *  import { TopTeaser } from '@artegeie/design-system/presse'
 *
 *
 *
 * const App = () =>
 *  let srcs = [
 *   {
 *     url:'https://www.arte.tv/sites/presse/files/099727-000-a_3472315-scaled.jpg',
 *     w: 864,
 *     h: 484,
 *   },
 * ]
*
 * <TopTeaser
 *   title={'My Title'}
 *   subtitle={'My subtitle'}
 *   description={'A description'}
 *   imageAlt='My image'
 *   imageSrc={srcs}
 *   href='http://arte.tv'
 * />
 *
 * ```
 *
  */
export const TopTeaser: React.FC<{
  readonly description: string; 
  readonly href: Atom_Box_href; 
  readonly imageAlt: Atom_Box_alt; 
  readonly imageSrc: Type_Teaser_resolution[]; 
  readonly ref_?: any; 
  readonly subtitle: string; 
  readonly title: string
}> = PresseBS.TopTeaser;

// tslint:disable-next-line:interface-over-type-literal
export type ProgramPage_Props = {
  readonly isPlayNextActivated: Type_Page_Program_isPlayNextActivated; 
  readonly onPlayNextChange: Type_Page_Program_onPlayNextChange; 
  readonly page: Presse_Page_t; 
  readonly playedProgramId?: Type_String_Teaser_Id_t; 
  readonly player: JSX.Element
};

/** 
 * @see {@link Type_Page}
 * @example
 * ```javascript
 *  import { ProgramPage } from '@artegeie/design-system/presse'
 *
 *  const App = () => <ProgramPage page={...} />
 * ```
 *
  */
export const ProgramPage: React.FC<{
  readonly isPlayNextActivated: Type_Page_Program_isPlayNextActivated; 
  readonly onPlayNextChange: Type_Page_Program_onPlayNextChange; 
  readonly page: Presse_Page_t; 
  readonly playedProgramId?: Type_String_Teaser_Id_t; 
  readonly player: JSX.Element
}> = PresseBS.ProgramPage;

// tslint:disable-next-line:interface-over-type-literal
export type RcPage_Props = { readonly page: Presse_Page_t };

/** 
 * @see {@link Type_Page}
 * @example
 * ```javascript
 *  import { RcPage } from '@artegeie/design-system/presse'
 *
 *  const App = () => <RcPage page={...} />
 * ```
 *
  */
export const RcPage: React.FC<{ readonly page: Presse_Page_t }> = PresseBS.RcPage;

// tslint:disable-next-line:interface-over-type-literal
export type AgendaPage_Props = {
  readonly getSelectedDate: (_1:Date) => void; 
  readonly initialDate: Date; 
  readonly labelAfternoonFilter: string; 
  readonly labelAllDayFilter: string; 
  readonly page: Presse_Page_Guide_t; 
  readonly selectedDate: Date; 
  readonly weekPrefixLabel: string
};

/** 
 * @see {@link Type_Page}
 * @example
 * ```javascript
 *  import { AgendaPage } from '@artegeie/design-system/presse'
 *
 *  const App = () =>{
 *  const initialDate = new Date()
 *  const selectedDate = new Date()
 *  const getSelectedDate = (date) => console.log(date)
*   const weekPrefixLabel= "PW"
*   const labelAllDayFilter="All Day"
*   const labelAfternoonFilter="12 Uhr - 20 Uhr"
* return (<AgendaPage page={...}
*         selectedDate={selectedDate}
*         initialDate={initialDate}
*         getSelectedDate={getSelectedDate}
*         weekPrefixLabel={weekPrefixLabel}
*         labelAllDayFilter={labelAllDayFilter}
*         labelAfternoonFilter={labelAfternoonFilter}
* />)
  }
 * ```
 *
  */
export const AgendaPage: React.FC<{
  readonly getSelectedDate: (_1:Date) => void; 
  readonly initialDate: Date; 
  readonly labelAfternoonFilter: string; 
  readonly labelAllDayFilter: string; 
  readonly page: Presse_Page_Guide_t; 
  readonly selectedDate: Date; 
  readonly weekPrefixLabel: string
}> = PresseBS.AgendaPage;

// tslint:disable-next-line:interface-over-type-literal
export type Header_Props = { readonly search: Organism_Header_search };

/** 
 * @remarks You have to have `I18nProvider`  above in your
 * components' tree
 * @see {@link I18nProvider}
 * @example
 * ```javascript
 *  import { Header, ConfigProvider, I18nProvider, UserProvider } from '@artegeie/design-system/presse'
 *
 *  const App = () =>
   <ConfigProvider api={...}
 *          baseUrl='https://www.arte.tv'
 *          trackPixel={...}
 *          playStoreUrl={...}
 *          appStoreUrl={...}
 *          vodStoreHomepageUrl={...}>
 *       <I18nProvider locale={...} labels={...} alternativeLanguages={...}>
 *            <Header {...props} />
 *       </I18nProvider>
 *       </ConfigProvider>
 * ```
 *
  */
export const Header: React.FC<{ readonly search: Organism_Header_search }> = PresseBS.Header;

// tslint:disable-next-line:interface-over-type-literal
export type Footer_Props = { readonly footerItems: Emac_Footer_t };

/** 
 * @remarks You have to have `I18nProvider`  above in your
 * components' tree
 * @see {@link I18nProvider}
 * @example
 * ```javascript
 *  import { Footer, ConfigProvider } from '@artegeie/design-system/presse'
 *
 *  const App = () =>
 *
 *        <ConfigProvider api={...}
 *          baseUrl='https://www.arte.tv'
 *          trackPixel={...}
 *          playStoreUrl={...}
 *          appStoreUrl={...}
 *          vodStoreHomepageUrl={...}>
 *         <Footer newsletterSource={...} footerItems={...} />
 *       </ConfigProvider>
 *
 * ```
 *
  */
export const Footer: React.FC<{ readonly footerItems: Emac_Footer_t }> = PresseBS.Footer;

// tslint:disable-next-line:interface-over-type-literal
export type Typography_Props = {
  readonly children: React.ReactNode; 
  readonly tag?: Atom_Box_text; 
  readonly textRef?: any; 
  readonly variant?: Atom_Text_Presse_variant
};

/** 
 * @example
 * ```javascript
 * import { Typography } from '@artegeie/design-system/presse'
 *
 * const App = () => <Typography tag="h1" variant="title">Hello world</Typography>
 * ```
 */
export const Typography: React.FC<{
  readonly children: React.ReactNode; 
  readonly tag?: Atom_Box_text; 
  readonly textRef?: any; 
  readonly variant?: Atom_Text_Presse_variant
}> = PresseBS.Typography;

// tslint:disable-next-line:interface-over-type-literal
export type Textfield_Props = {
  readonly ariaLabel?: string; 
  readonly autoComplete?: Atom_Textfield_autoComplete; 
  readonly id?: string; 
  readonly inputRef?: React.Ref<unknown>; 
  readonly name?: string; 
  readonly onBlur?: Atom_Textfield_onBlur; 
  readonly onChange?: Atom_Textfield_onChange; 
  readonly pattern?: Type_Pattern_t; 
  readonly placeholder?: string; 
  readonly readOnly?: boolean; 
  readonly required?: boolean; 
  readonly title?: string; 
  readonly type_?: string; 
  readonly value?: string
};

/** 
 * @example
 * ```javascript
 * import { Textfield } from '@artegeie/design-system/presse'
 *const autoComplete= "email" ////  values allowed:  email | Off |  newPassword |  currentPassword
 * const App = () => <Textfield type_="email" required=true pattern="Email" placeholder="Adresse e-mail" autoComplete />
 * ````
 */
export const Textfield: React.FC<{
  readonly ariaLabel?: string; 
  readonly autoComplete?: Atom_Textfield_autoComplete; 
  readonly id?: string; 
  readonly inputRef?: React.Ref<unknown>; 
  readonly name?: string; 
  readonly onBlur?: Atom_Textfield_onBlur; 
  readonly onChange?: Atom_Textfield_onChange; 
  readonly pattern?: Type_Pattern_t; 
  readonly placeholder?: string; 
  readonly readOnly?: boolean; 
  readonly required?: boolean; 
  readonly title?: string; 
  readonly type_?: string; 
  readonly value?: string
}> = function Presse_Textfield(Arg1: any) {
  const $props = {ariaLabel:Arg1.ariaLabel, autoComplete:Arg1.autoComplete, id:Arg1.id, inputRef:Arg1.inputRef, name:Arg1.name, onBlur:Arg1.onBlur, onChange:Arg1.onChange, pattern:(Arg1.pattern == null ? undefined : 0), placeholder:Arg1.placeholder, readOnly:Arg1.readOnly, required:Arg1.required, title:Arg1.title, type_:Arg1.type_, value:Arg1.value};
  const result = React.createElement(PresseBS.Textfield, $props);
  return result
};

// tslint:disable-next-line:interface-over-type-literal
export type Button_Props = {
  readonly disabled?: Atom_Cta_Ds_Presse_disabled; 
  readonly label: string; 
  readonly onClick?: (_1:MouseEvent) => void; 
  readonly type_?: Atom_Box_type_; 
  readonly variant?: Atom_Cta_Presse_Button_presseStyle
};

/** 
 * @example
 * ```javascript
 * import { Button } from '@artegeie/design-system/presse'
 *
 * const App = () => <Button label="Label" onClick={() => console.log('click')} type_="submit"/>
 * ````
 */
export const Button: React.FC<{
  readonly disabled?: Atom_Cta_Ds_Presse_disabled; 
  readonly label: string; 
  readonly onClick?: (_1:MouseEvent) => void; 
  readonly type_?: Atom_Box_type_; 
  readonly variant?: Atom_Cta_Presse_Button_presseStyle
}> = PresseBS.Button;

// tslint:disable-next-line:interface-over-type-literal
export type Dropdown_Props = {
  readonly autoComplete?: Atom_Select_autoComplete; 
  readonly iconColor?: Atom_Icon_Ds_color; 
  readonly id?: string; 
  readonly items: Type_Dropdown_Item_t[]; 
  readonly name: Atom_Box_name; 
  readonly onBlur?: Atom_Select_onBlur; 
  readonly onChange: (_1:Type_Dropdown_Item_t) => void; 
  readonly value?: Type_Dropdown_Item_value; 
  readonly variant?: Organism_Dropdown_Ds_Select_variant
};

/** 
 * @example
 * ```javascript
 * import { Dropdown } from '@artegeie/design-system/presse'
 *
 * const items = [
 *    { label: 'labelOne', value: 'one' },
 *    { label: 'labelTwo', value: 'two' }
 * ]
 * const handlerFunction = ({label, value}) => myHandlerFunction(label, value)
 * const autoComplete = "off" ////  values allowed:  [honorificPrefix |birthdayDay |birthdayMonth |birthdayYear |countryName| off ]
 * const App = () => <Dropdown name="myDropdown" items=items value={currentItem.value} onChange={handlerFunction} autoComplete/>
 * ````
 */
export const Dropdown: React.FC<{
  readonly autoComplete?: Atom_Select_autoComplete; 
  readonly iconColor?: Atom_Icon_Ds_color; 
  readonly id?: string; 
  readonly items: Type_Dropdown_Item_t[]; 
  readonly name: Atom_Box_name; 
  readonly onBlur?: Atom_Select_onBlur; 
  readonly onChange: (_1:Type_Dropdown_Item_t) => void; 
  readonly value?: Type_Dropdown_Item_value; 
  readonly variant?: Organism_Dropdown_Ds_Select_variant
}> = PresseBS.Dropdown;

// tslint:disable-next-line:interface-over-type-literal
export type InputLabel_Props = {
  readonly htmlFor: string; 
  readonly label: string; 
  readonly tag?: Atom_Box_text; 
  readonly variant?: Atom_Text_Presse_variant
};

/** 
 * @example
 * ```javascript
 * import { InputLabel } from '@artegeie/design-system/presse'
 * import { Textfield } from '@artegeie/design-system/presse'
 * const App = () => <>
 *<InputLabel htmlFor="input" label="input label" tag="p" variant="default"/>
 *<Textfield id="input" />
 *</>
 * ````
 */
export const InputLabel: React.FC<{
  readonly htmlFor: string; 
  readonly label: string; 
  readonly tag?: Atom_Box_text; 
  readonly variant?: Atom_Text_Presse_variant
}> = PresseBS.InputLabel;

// tslint:disable-next-line:interface-over-type-literal
export type Checkbox_Props = {
  readonly checked?: boolean; 
  readonly id: Atom_Box_htmlFor; 
  readonly label: JSX.Element; 
  readonly name?: string; 
  readonly onBlur?: (_1:ReactEvent_Focus_t) => void; 
  readonly onClick: (_1:boolean) => void; 
  readonly required?: boolean
};

export const Checkbox: React.FC<{
  readonly checked?: boolean; 
  readonly id: Atom_Box_htmlFor; 
  readonly label: JSX.Element; 
  readonly name?: string; 
  readonly onBlur?: (_1:ReactEvent_Focus_t) => void; 
  readonly onClick: (_1:boolean) => void; 
  readonly required?: boolean
}> = PresseBS.Checkbox;
